import React from "react";

import "./icon.scss";

const Icon = ({ name, type, renderImgTag, className }) => {
  const [Icon, setIcon] = React.useState("");

  React.useEffect(() => {
    fetch(`/images/${type || "logos"}/${name}.svg`)
      .then((res) => res.text())
      .then((res) => {
        if (res.startsWith("<svg")) return setIcon(res);
        return setIcon("");
      });
  }, [name, type]);

  if (type === "icons") {
    switch (name) {
      case "mail":
        return (
          <img
            className={`icon__image ${className}`}
            src="/images/icons/mail.png"
            alt="mail icon"
            loading="lazy" 
          />
        );
      case "telefon":
        return (
          <img
            className={`icon__image ${className}`}
            src="/images/icons/telefon.png"
            alt="telefon icon"
            loading="lazy" 
          />
        );
      case "linkedin":
        return (
          <img
            className={`icon__image ${className}`}
            src="/images/icons/linkedin.png"
            alt="linkedin icon"
            loading="lazy" 
          />
        );
      default:
        return (
          <img
            className={`icon__image ${className}`}
            src="/images/icons/mail.png"
            alt="mail icon"
            loading="lazy" 
          />
        );
    }
  }

  if (renderImgTag) {
    return (
      <img
        className={`icon__image ${className}`}
        src={`/images/${type || "logos"}/${name}.svg`}
        alt={name}
        loading="lazy"
      />
    );
  }

  if (!Icon) return null;

  return (
    <div
      className={`icon ${className} ${name}`}
      dangerouslySetInnerHTML={{ __html: Icon }}
    />
  );
};

export default Icon;
